export default "__VITE_ASSET__B7RVK0T3__"